import * as React from 'react';

export const Cross = (props: { className?: string }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" color="#292929" className={`trustpilot-icon ${(props.className)}`} xmlns="http://www.w3.org/2000/svg">
        <g id="16x16_Miscellaneous" stroke-width="1" fill-rule="evenodd">
            <g id="ic-cross">
                <path id="bounds" d="M0 0h16v16H0z"></path>
                <path d="M6.429 8L3.325 4.897a1.111 1.111 0 1 1 1.572-1.572L8 6.43l3.103-3.104a1.111 1.111 0 1 1 1.572 1.572L9.57 8l3.104 3.103a1.111 1.111 0 1 1-1.572 1.572L8 9.57l-3.103 3.104a1.111 1.111 0 1 1-1.572-1.572L6.43 8z" id="icon" fill-rule="nonzero"></path>
            </g>
        </g>
    </svg>
);
